import { render, staticRenderFns } from "./DataBankMenu.vue?vue&type=template&id=dca13692&scoped=true&"
import script from "./DataBankMenu.vue?vue&type=script&lang=js&"
export * from "./DataBankMenu.vue?vue&type=script&lang=js&"
import style0 from "./DataBankMenu.vue?vue&type=style&index=0&id=dca13692&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca13692",
  null
  
)

export default component.exports